import get from 'get-value';
export var getLogoWidth = function getLogoWidth(headerElement) {
  var logoElement = get(headerElement, ['children', 0, 'childNodes', 0]);
  return logoElement ? logoElement.clientWidth : 0;
};